/**
 * PURE SKY Global JavaScript
 * Shopify-specific global functionality
 */

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('PURE SKY theme loaded');
  
  // Add smooth scroll behavior
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

// Shopify Section Event Listeners
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    console.log('Section loaded:', event.detail.sectionId);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    console.log('Section unloaded:', event.detail.sectionId);
  });

  document.addEventListener('shopify:section:select', function(event) {
    console.log('Section selected:', event.detail.sectionId);
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    console.log('Section deselected:', event.detail.sectionId);
  });

  document.addEventListener('shopify:block:select', function(event) {
    console.log('Block selected:', event.detail.blockId);
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    console.log('Block deselected:', event.detail.blockId);
  });
}
